import React from "react";
import * as LucideIcons from "lucide-react";

/**
 * AnimatedServiceIcon — wraps a Lucide icon with a service-specific
 * micro-animation triggered by the parent `.group:hover` state.
 *
 * Each service slug maps to a distinct CSS animation keyframe defined
 * in App.css so the bundle stays small and dependency-free (no Lottie).
 */
const ANIMATION_BY_SLUG = {
  "port-clearance-transit-log": "anim-stamp-down",     // FileCheck2: subtle "stamp" tap
  "berth-reservations": "anim-anchor-sway",            // Anchor: nautical sway
  "customs-immigration": "anim-stamp-rotate",          // Stamp: rotate-stamp
  "bunkering": "anim-fuel-pulse",                      // Fuel: drop pulse
  "provisioning": "anim-tilt",                         // UtensilsCrossed: tilt
  "crew-guest-logistics": "anim-people-bounce",        // Users: tiny bounce
  "technical-support": "anim-spin-wrench",             // Wrench: rotate
  "concierge": "anim-gem-shimmer",                     // Gem: scale shimmer
  "cruising-support": "anim-compass-spin",             // Compass: rotate slow
};

const AnimatedServiceIcon = ({ slug, iconName, size = 28, className = "" }) => {
  const Icon = LucideIcons[iconName] || LucideIcons.Anchor;
  const animClass = ANIMATION_BY_SLUG[slug] || "anim-tilt";
  return (
    <span
      className={`inline-flex items-center justify-center text-brand origin-center service-icon-wrap ${animClass} ${className}`}
      data-testid={`service-icon-${slug}`}
    >
      <Icon size={size} strokeWidth={1.25} />
    </span>
  );
};

export default AnimatedServiceIcon;
